/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'barbed',
    quality: 0.3,
    damageMod: 0.15
}